<script lang="ts" setup>
import {usePage} from "~/composables/usePage";

const {collectionUri, pageUri} = useI18nCollection();
const {getAllButIndex} = usePage();
const hero = await queryCollection(collectionUri('team')).path(pageUri('team/hero')).first();
const pages = await queryCollection(collectionUri('team')).all();
const founders = getAllButIndex(pages).filter(page => page.path.includes('founders/'));
const { t } = useI18n();

// SEO optimization
useSeo({
  title: hero?.seoTitle || t('seo.team.title'),
  description: hero?.seoDescription || t('seo.team.description'),
});
</script>

<template>
  <main>
    <SectionPageHeader :page="hero"/>
    <SectionArticleBlock
            v-for="(founder, index) in founders"
            :key="founder.id"
            :odd="index % 2 === 1"
            :page="founder"
            class="page-container-md"/>

    <SectionArticlesGrid
            :pages="pages.filter(page =>  page.path.includes('/support'))"
            class="mb-8"
    />
    <SectionArticlesGrid
            :pages="pages.filter(page =>  page.path.includes('/commercial'))"
    />
    <div class="p-2">
      <div class="bg-brand/30 py-8 rounded-img">
        <div class="page-container">
          <ArticleLayout
                  :page="pages.find(p => p.path.includes('additional'))!"
                  content-class="tablet:max-w-1/2 mx-auto"
                  img-aspect-ratio="aspect-16/12 tablet:aspect-100/50"
          />
        </div>
      </div>
    </div>

    <SectionAermecHistory :pages="pages.filter(p => p.path.includes('/history'))"/>
  </main>
</template>